import { AppCurrentVisits } from '../../../sections/@dashboard/app';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';

export default function MeetingsByPlatformPieChart({ theme, totalMeetingsByPlatform }) {
  const [range, setRange] = useState('month'); // 'month' | 'total'

  const toggle = (
    <ToggleButtonGroup
      value={range}
      exclusive
      onChange={(_, val) => val && setRange(val)}
      size="small"
      sx={{
        '& .MuiToggleButton-root': {
          color: 'white',
          borderColor: 'rgba(255,255,255,0.5)',
          textTransform: 'none',
          px: 1.5,
        },
        '& .MuiToggleButton-root.Mui-selected': {
          backgroundColor: 'rgba(255,255,255,0.9)',
          color: 'primary.main',
          '&:hover': { backgroundColor: 'white' },
        },
      }}
    >
      <ToggleButton value="month">Último mes</ToggleButton>
      <ToggleButton value="total">Total</ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <AppCurrentVisits
      title="Reuniones por plataforma"
      isCost={false}
      showLabels={true}
      action={toggle}
      chartData={range === 'month' ? totalMeetingsByPlatform.lastMonth : totalMeetingsByPlatform.total}
      chartColors={[
        theme.palette.chart.red[0],
        theme.palette.chart.blue[0],
        theme.palette.chart.violet[0],
        theme.palette.chart.green[0],
      ]}
    />
  );
}

MeetingsByPlatformPieChart.propTypes = {
  theme: PropTypes.any,
  totalMeetingsByPlatform: PropTypes.arrayOf(PropTypes.number),
};
